module.exports = __webpack_public_path__ + "img/p14.63fd2418.jpg";